var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentCopyOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "duplicate",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 19,
    height: 22,
    fill: "#333"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#334856",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2107",
    "data-name": "Groupe 2107",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2106",
    "data-name": "Groupe 2106",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_776",
    "data-name": "Trac\\xE9 776",
    d: "M14,0H2A2.006,2.006,0,0,0,0,2V16H2V2H14Zm3,4H6A2.006,2.006,0,0,0,4,6V20a2.006,2.006,0,0,0,2,2H17a2.006,2.006,0,0,0,2-2V6a2.006,2.006,0,0,0-2-2m0,16H6V6H17Z",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopyOutlined);
export default __webpack_public_path__ + "static/media/ContentCopyOutlined.6c369cadb13d0ff7e0a92fa27bac5940.svg";
export { ForwardRef as ReactComponent };